import React, { useState } from 'react';
import PublicacionesInfo from '../../json/publicaciones';
import './publicaciones.css';

export default function Publicaciones({ publications = PublicacionesInfo }) {
 
  return (
    <div className="pub-gallery-container">
      {/* Header */}
      <header >
        <h3 className='title'> PUBLICACIONES </h3>
      <hr className='hr-gob'/>
        {/* <p className="pub-header-subtitle">Explora nuestras últimas publicaciones y documentos digitales</p> */}
      </header>

      {/* Grid de Publicaciones */}
      <main className="pub-grid">
        {publications.map((pub) => (
          <article key={pub.id} className="pub-card">
            <div className="pub-cover-wrapper" 
                onClick={() => window.open(pub.pdfUrl, '_blank', 'noopener,noreferrer')}
                style={{ cursor: 'pointer' }}
>
              <img src={pub.coverImage} alt={pub.title} className="pub-cover-image" />
              <div className="pub-cover-overlay">
                <button className="pub-view-btn" type="button">
                  
                  <span>Leer PDF</span>
                </button>
              </div>
            </div>

            <div className="pub-info">
              <span className="pub-badge">{pub.category}</span>
              <h2 className="pub-title">{pub.title}</h2>
              <p className="pub-author">{pub.author}</p>

              <div className="pub-meta">
                <span>{pub.date}</span>
                <span>{pub.pages}</span>
              </div>
            </div>
          </article>
        ))}
      </main>
    </div>
  );
}